import ReviewForm from 'components/organisms/ReviewForm'
import * as React from 'react'

export interface IReviewFormProps {
  review: any
  reservation: any
  post: any
  post_images: any[]
  reviewer: any
}

const ReviewNew: React.FC<IReviewFormProps> = props => {
  return <ReviewForm {...props} />
}

export default ReviewNew
